import Seo from "@/components/Seo";
import { CoveButton } from "@/components/CoveButton";
import { MaskedText } from "@/components/motion";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" description="The page you're looking for can't be found. Return to the Cranio Cove home page." path="/404" />
      <section className="min-h-[80svh] flex items-center px-6 md:px-12 grain" data-testid="notfound-section">
        <div className="mx-auto max-w-[1400px] w-full">
          <p className="text-xs tracking-[0.25em] uppercase text-cove-rose mb-6">Lost the path</p>
          <h1 className="font-serif text-6xl md:text-8xl leading-[0.9] text-cove-slate">
            <MaskedText lines={["This quiet corner", "doesn't exist."]} />
          </h1>
          <p className="mt-8 max-w-md text-lg text-cove-olive">
            Let's guide you back somewhere calm and familiar.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <CoveButton to="/" variant="primary" testId="notfound-home-button">Return Home</CoveButton>
            <CoveButton to="/contact" variant="secondary" testId="notfound-contact-button">Contact Laura</CoveButton>
          </div>
        </div>
      </section>
    </>
  );
}
